import { showAlert } from "@common/helper";
import { QueryCache, QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: () => {
      showAlert("Failed to load data from server!", "error");
    },
  }),
});

export default queryClient;
